import { ExportButton, FilterButton, TopToolbar, useListContext, useNotify } from 'react-admin';
import { EXPORT_MAX_ROWS } from './csvExport';

/**
 * Eksport całej listy, a gdy się nie da — z ostrzeżeniem, nie po cichu.
 *
 * Przycisk react-admina pobiera `maxResults` wierszy (domyślnie 1000)
 * i nie mówi, że reszty nie ma. Podnosimy to do sufitu API, a przy liście
 * większej od niego operator dostaje komunikat, ile wierszy nie weszło —
 * wtedy trzeba zawęzić filtr.
 */
export const ExportAllButton = () => {
  const { total } = useListContext();
  const notify = useNotify();
  const onClick = () => {
    if (typeof total === 'number' && total > EXPORT_MAX_ROWS) {
      notify(
        `Eksport obejmie pierwsze ${EXPORT_MAX_ROWS} z ${total} wierszy — zawęź filtr, żeby pobrać resztę.`,
        { type: 'warning' },
      );
    }
  };
  return <ExportButton maxResults={EXPORT_MAX_ROWS} onClick={onClick} />;
};

/** Pasek akcji listy: filtry i eksport całości (bez tworzenia — listy z TMS są tylko do odczytu). */
export const ListExportActions = () => (
  <TopToolbar>
    <FilterButton />
    <ExportAllButton />
  </TopToolbar>
);
